module.exports = __webpack_public_path__ + "img/22.1eb31ed5.png";